import type { AxiosInstance } from 'axios'
import type { IFactoryFunctionRequest, IFactoryResponse } from '@bc-library/interface'
import { EMethod } from '@bc-library/interface'
import { API_MAIN_VERSION, BASE_URL } from '@/config/constantes'
import useAxios from '@/services/api/useAxios'

const resource = 'jobOfferStatistics'

export type JobOfferStatDaily = {
  date: string
  views: number
  applies: number
}

export type JobOfferStatWeekday = {
  weekday: number
  views: number
  applies: number
}

export type JobOfferStatChannel = {
  /** Job board key of `?source=`, null for the career site itself */
  channel: string | null
  views: number
  applies: number
}

export type JobOfferStatsResponse = {
  startDate: string
  endDate: string
  visitCount: number
  applyCount: number
  daily: JobOfferStatDaily[]
  byWeekday: JobOfferStatWeekday[]
  byChannel?: JobOfferStatChannel[]
}

const viewCount = (axios: IFactoryFunctionRequest<{ viewCount: number }, { viewCount: number }>) => ({ offerId }: { offerId: string }): IFactoryResponse<{ viewCount: number }, { viewCount: number }> => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/viewCount/${offerId}`,
  })
}

const getByOfferId = (axios: IFactoryFunctionRequest<JobOfferStatsResponse, undefined>) => ({
  offerId,
  query,
}: {
  offerId: string
  query?: { startDate?: string; endDate?: string }
}): IFactoryResponse<JobOfferStatsResponse, undefined> => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/${offerId}`,
    query,
    immediate: false,
  })
}

export default (axios: AxiosInstance) => ({
  viewCount: viewCount(useAxios(axios)),
  getByOfferId: getByOfferId(useAxios(axios)),
})
